import axios from "axios";
import { API_BASE_URL, TOKEN_STORAGE_KEY } from "./config";

const baseURL = API_BASE_URL || (typeof window !== "undefined"
  ? ((window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? "" : "/api")
  : "http://backend:5000");

export const api = axios.create({ baseURL });
export const publicApi = axios.create({ baseURL });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY) || sessionStorage.getItem(TOKEN_STORAGE_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
